///<reference path='../typings/index.d.ts' />
///<reference path='config.ts' />
///<reference path='manifest/assets.ts' />
///<reference path='cardbase.ts' />

module agi.expressions.card {
    import MovieClip = PIXI.extras.MovieClip;
    import Config = agi.expressions.card.Config;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;

    export class Card extends CardBase {
        constructor(options:CardOptions){
            if (options.assetPath !== undefined){
                Config.ASSET_PATH = options.assetPath;
            }
            // data about this card
            var cardData = <CardData>{};
            var assetManifest:AssetManifest = new AssetManifest(Config.ASSET_PATH);
            var musicUrls:string[] = assetManifest.audioUrls[0];
            var soundFxUrls:string[] = assetManifest.audioUrls[1];
            cardData.sendCallback = options.sendCallback;
            cardData.setPersonalizationsCallback = options.setPersonalizationsCallback;
            cardData.background = 'Background/bg_square.png';
            options.cardData = cardData;
            options.assetManifest = assetManifest;

            super(options);            
        }


    }
}
